import { Building2, Clapperboard, ExternalLink, Play } from 'lucide-react'
import {
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from '@/components/ui/dropdown-menu'
import { PORTAL_URL, VIEWER_URL } from '@/lib/appUrls'
import type { MyApps } from '@/lib/myApps'

type KinoraApp = 'guild' | 'portal' | 'viewer'

type AccountHatLinksProps = {
  apps: MyApps | null
  currentApp: KinoraApp
}

export function AccountHatLinks({ apps, currentApp }: AccountHatLinksProps) {
  if (!apps) return null

  const showViewer = apps.viewer && currentApp !== 'viewer'
  const showStudio = apps.studio && currentApp !== 'portal'

  if (!showViewer && !showStudio) return null

  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuLabel>Other Kinora apps</DropdownMenuLabel>
      {showViewer && (
        <DropdownMenuItem asChild>
          <a href={VIEWER_URL} target="_blank" rel="noreferrer">
            <Play className="size-4" />
            Open Kinora Viewer
            <ExternalLink className="ml-auto size-3.5 opacity-60" />
          </a>
        </DropdownMenuItem>
      )}
      {showStudio && (
        <DropdownMenuItem asChild>
          <a href={PORTAL_URL} target="_blank" rel="noreferrer">
            <Building2 className="size-4" />
            Open Publisher Portal
            <ExternalLink className="ml-auto size-3.5 opacity-60" />
          </a>
        </DropdownMenuItem>
      )}
    </>
  )
}

/** Plain anchor rows for mobile menus (no dropdown primitives). */
export function AccountHatLinkRows({
  apps,
  currentApp,
  onNavigate,
}: AccountHatLinksProps & { onNavigate?: () => void }) {
  if (!apps) return null

  const showViewer = apps.viewer && currentApp !== 'viewer'
  const showStudio = apps.studio && currentApp !== 'portal'

  if (!showViewer && !showStudio) return null

  const linkClass =
    'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium text-muted-foreground transition-colors hover:bg-sidebar-accent/60 hover:text-sidebar-foreground'

  return (
    <>
      <p className="px-3 pt-2 text-xs font-medium text-muted-foreground">Other Kinora apps</p>
      {showViewer && (
        <a href={VIEWER_URL} target="_blank" rel="noreferrer" className={linkClass} onClick={onNavigate}>
          <Play className="size-4" />
          Open Kinora Viewer
          <ExternalLink className="ml-auto size-3.5 opacity-60" />
        </a>
      )}
      {showStudio && (
        <a href={PORTAL_URL} target="_blank" rel="noreferrer" className={linkClass} onClick={onNavigate}>
          <Building2 className="size-4" />
          Open Publisher Portal
          <ExternalLink className="ml-auto size-3.5 opacity-60" />
        </a>
      )}
    </>
  )
}